module.exports = __webpack_public_path__ + "img/loginbg.979976f9.png";